import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.proto.js";
import { nsAtlasPlansDetailGET } from '@/remote';
import { handleTaskIds } from './handleTaskIds';

/**
 * 前端处理弹框场景：除了配置外，可支持自定义处理
 */
export function handleSrc4feScene(_x, _x2, _x3, _x4, _x5) {
  return _handleSrc4feScene.apply(this, arguments);
}
/**
 * 前端处理弹框场景：
 * "/api/atlas/plans/review/status|POST" 更新评审状态时
 */
function _handleSrc4feScene() {
  _handleSrc4feScene = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, method, params, _ref, resolve) {
    var entitySrc, entityKey, entityType, eventId, pointId;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          entitySrc = _ref.entitySrc, entityKey = _ref.entityKey, entityType = _ref.entityType, eventId = _ref.eventId, pointId = _ref.pointId;
          console.info("\u524D\u7AEF\u5904\u7406\u5F39\u6846\u573A\u666F\uFF1A\"".concat(url, "|").concat(method, "\", handleSrc4feScene"));
          if (url === '/api/atlas/plans/review/status' && method === 'POST') {
            // 更新评审状态时
            handleUpdateReviewStatus(params, {
              entitySrc: entitySrc,
              entityKey: entityKey,
              entityType: entityType,
              eventId: eventId,
              pointId: pointId
            }, resolve);
          }
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _handleSrc4feScene.apply(this, arguments);
}
function handleUpdateReviewStatus(_x6, _x7, _x8) {
  return _handleUpdateReviewStatus.apply(this, arguments);
}
function _handleUpdateReviewStatus() {
  _handleUpdateReviewStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params, _ref2, resolve) {
    var entitySrc, entityKey, entityType, eventId, pointId, respData, taskIds;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          entitySrc = _ref2.entitySrc, entityKey = _ref2.entityKey, entityType = _ref2.entityType, eventId = _ref2.eventId, pointId = _ref2.pointId;
          _context2.n = 1;
          return nsAtlasPlansDetailGET.remote({
            planId: params.planId
          });
        case 1:
          respData = _context2.v;
          taskIds = respData.taskIds;
          handleTaskIds({
            taskIds: taskIds,
            eventId: eventId,
            pointId: pointId
          }, resolve);
        case 2:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _handleUpdateReviewStatus.apply(this, arguments);
}